import { render } from "./leaderboard.svg?vue&type=template&id=977971a0"
const script = {}
script.render = render

export default script